<!--
 * @Description:

 * @Date: 2018-12-21 17:03:28
 * @LastEditors: wjx
 * @LastEditTime: 2020-11-17 18:42:57
 -->
<template>
  <div class="send-msg-code">
    <el-button type="primary" class="btn" @click="sendMsg">
      {{ time == 0 ? '获取验证码' : `${time}s` }}
    </el-button>
  </div>
</template>

<script>
import { setInterval, setTimeout } from 'timers';
export default {
  data() {
    return {
      time: 0
    };
  },
  props: {
    phone: {
      type: String | Number
    },
    imgCode: {
      type: String | Number
    },
    getMsgCodeFn: {
      type: Function
    }
  },
  computed: {},
  methods: {
    sendMsg() {
      if (this.time != 0) {
        this.$message({
          message: '短信验证码已发送，请稍后再试',
          type: 'warning'
        });
        return;
      }
      if (`${this.imgCode}`.length < 4) {
        this.$notify({
          title: '失败',
          message: '请输入有效的图形验证码~',
          type: 'error'
        });
        return;
      }
      this.getMsgCodeFn({
        phone: this.phone,
        imgVerifyCode: this.imgCode
      })
        .then(res => {
          this.time = 60;
          this.$message({
            message: '验证码发送成功，请注意查收',
            type: 'success'
          });
          this.countDown(this.time);
        })
        .catch(err => {
          this.$emit('error');
        });
    },
    countDown(nowTime) {
      if (nowTime > 0) {
        setTimeout(() => {
          this.time = --nowTime;
          this.countDown(this.time);
        }, 1000);
      }
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  filters: {}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.send-msg-code {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn {
    width: 104px;
    height: 100%;
    border-radius: 2px;
    border: 1px solid #1890ff;
    color: #1890ff;
    background: #fff;
    display: inline-block;
    padding: 0;
  }
}
</style>
